import { Component } from '@angular/core';

@Component({
  selector: 'app-clear-and-exit',
  templateUrl: './clear-and-exit.component.html',
  styleUrls: ['./clear-and-exit.component.scss']
})
export class ClearAndExitComponent {

}
